import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/Login.css';

const Login = ({ onClose }) => {
  const { login, cargando, error, setError, restaurarSesion } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);

  // Restaurar sesión al montar el componente
  useEffect(() => {
    restaurarSesion();
  }, [restaurarSesion]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !email.includes('@')) {
      setError('Por favor ingresa un email válido');
      return;
    }
    if (!password || password.length < 4) {
      setError('La contraseña debe tener al menos 4 caracteres');
      return;
    }

    const exito = await login(email, password);
    if (exito && onClose) {
      onClose();
    }
  };

  return (
    <div className="login-overlay" onClick={(e) => e.target === e.currentTarget && onClose && onClose()}>
      <div className="login-modal">
        <div className="login-header">
          <h2>🔑 Acceso Admin</h2>
          {onClose && (
            <button className="btn-cerrar-login" onClick={onClose} title="Cerrar">✕</button>
          )}
        </div>

        <div className="login-body">
          <p className="login-descripcion">
            Inicia sesión para acceder al panel de administración y editar productos.
          </p>

          <form className="formulario-login" onSubmit={handleSubmit}>
            <div className="form-grupo-login">
              <label htmlFor="login-email">Email</label>
              <input
                type="email"
                id="login-email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                placeholder="admin@tienda.com"
                autoComplete="email"
                disabled={cargando}
              />
            </div>

            <div className="form-grupo-login">
              <label htmlFor="login-password">Contraseña</label>
              <div className="input-password-wrapper">
                <input
                  type={mostrarPassword ? 'text' : 'password'}
                  id="login-password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError(''); }}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  disabled={cargando}
                />
                <button
                  type="button"
                  className="btn-toggle-password"
                  onClick={() => setMostrarPassword(!mostrarPassword)}
                  title={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  {mostrarPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            {error && <div className="error-login">{error}</div>}

            <button
              type="submit"
              className="btn-login"
              disabled={cargando}
            >
              {cargando ? '⏳ Iniciando sesión...' : '🔓 Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
